<template>
  <component :is="tag" v-tippy="tippyProps" class="hint-wrapper">
    <slot />
  </component>
</template>

<script setup>import { computed as _computed } from 'vue';
import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const restProps = createPropsRestProxy(__props, ["tag"]);

  import { directive as vTippy } from "vue-tippy";

  import hintProps from "./lib/hint-props";

  defineProps({
    tag: { type: String, default: "div" },
    ...hintProps,
  })

  const tippyProps = _computed(() => ({
    // Must exceed our modal z-index (2147483640 in bulma_ext.scss)
    zIndex: 2147483647,
    ...restProps,
  }));
</script>

<style scoped lang="scss">
  .hint-wrapper {
    display: inline-flex;
    cursor: pointer;
  }
</style>
